




import React, { useEffect, useState, useRef } from 'react';
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import Fooduserwalletorders from './Fooduserwalletorders';
import './fooduserorders.css';

const filterSelectStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 10px",
};

const filterButtonStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 15px",
    cursor: "pointer",
};

const Fooduserorders = () => {
    const [allOrders, setAllOrders] = useState([]); // Store all orders
    const [filteredOrders, setFilteredOrders] = useState([]); // Store filtered results
    const [displayedOrders, setDisplayedOrders] = useState([]); // Store paginated results
    const [totalOrders, setTotalOrders] = useState(0);
    const [selectedDate, setSelectedDate] = useState("");
    const [page, setPage] = useState(0);
    const [viewType, setViewType] = useState("orders");
    const [searchTerm, setSearchTerm] = useState("");
    const [searchType, setSearchType] = useState("orderId"); // Default search type
    const [loading, setLoading] = useState(false);

    const { showLoader, hideLoader } = useLoader();
    const pageSize = 10;

    // Search options
    const searchOptions = [
        { value: "orderId", label: "Order ID" },
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Name" },
        { value: "companyName", label: "Company Name" },
        { value: "category", label: "Category" }
    ];

    // Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "orderId": return "Search Order ID";
            case "vendorId": return "Search Vendor ID";
            case "name": return "Search Name";
            case "companyName": return "Search Company Name";
            case "category": return "Search Category (Food/Catering)";
            default: return "Search...";
        }
    };

    // ⭐ Fetch ALL orders from backend
    const fetchAllOrders = async (forceRefresh = false) => {
        if (allOrders.length > 0 && !forceRefresh) {
            // Already have data, just apply filters
            applyFilters();
            return;
        }

        setLoading(true);
        showLoader();
        try {
            const token = localStorage.getItem("authToken");
            const headers = token ? { Authorization: `Bearer ${token}` } : {};

            // Fetch first page to get total count
            const initialRes = await fetch(`https://backend.maamaas.com/food/api/orders/getall/0/100`, {
                method: "GET",
                headers
            });
            const initialData = await initialRes.json();

            let allData = [];

            if (Array.isArray(initialData)) {
                allData = [...initialData];

                // If we got 100 items, there might be more
                if (initialData.length === 100) {
                    // Try to fetch next page
                    try {
                        const secondRes = await fetch(`https://backend.maamaas.com/food/api/orders/getall/1/100`, {
                            method: "GET",
                            headers
                        });
                        const secondData = await secondRes.json();
                        if (Array.isArray(secondData)) {
                            allData = [...allData, ...secondData];
                        }
                    } catch (e) {
                        console.log("No more pages");
                    }
                }
            }

            setAllOrders(allData);

            // Apply initial filters
            const filtered = applyFiltersToData(allData, selectedDate, searchTerm, searchType);
            setFilteredOrders(filtered);
            setTotalOrders(filtered.length);

            // Set first page
            setDisplayedOrders(filtered.slice(0, pageSize));

        } catch (err) {
            console.error("Error fetching orders:", err);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    // ⭐ Apply filters to data
    const applyFiltersToData = (data, date, search, type) => {
        return data.filter(item => {
            // Date filter
            if (date) {
                const itemDate = new Date(item.orderDateAndTime).toISOString().split('T')[0];
                if (itemDate !== date) return false;
            }

            // Search filter
            if (search.trim() !== "") {
                const searchLower = search.toLowerCase().trim();

                switch (type) {
                    case "orderId":
                        return item.orderId?.toString().toLowerCase().includes(searchLower);
                    case "vendorId":
                        return item.vendorId?.toString().toLowerCase().includes(searchLower);
                    case "name":
                        return item.userName?.toLowerCase().includes(searchLower);
                    case "companyName":
                        return item.userCompany?.toLowerCase().includes(searchLower);
                    case "category":
                        return item.appType?.toLowerCase().includes(searchLower);
                    default:
                        return true;
                }
            }

            return true;
        });
    };

    // ⭐ Apply filters and update pagination
    const applyFilters = () => {
        const filtered = applyFiltersToData(allOrders, selectedDate, searchTerm, searchType);
        setFilteredOrders(filtered);
        setTotalOrders(filtered.length);
        setPage(0);
        setDisplayedOrders(filtered.slice(0, pageSize));
    };

    // ⭐ Initial fetch
    useEffect(() => {
        fetchAllOrders();
    }, []);

    // ⭐ Update displayed data when page changes
    useEffect(() => {
        if (filteredOrders.length > 0) {
            const start = page * pageSize;
            const end = start + pageSize;
            setDisplayedOrders(filteredOrders.slice(start, end));
        }
    }, [page, filteredOrders]);

    // ⭐ Handle filter changes
    const handleFilterChange = () => {
        setPage(0);
        applyFilters();
    };

    // ⭐ Export CSV
    const handleExport = () => {
        if (filteredOrders.length === 0) {
            alert("No data available for export.");
            return;
        }

        try {
            const headersCSV = [
                "S.NO", "Order ID", "Vendor ID", "Company Name", "Date", "Time", "Category", "Type",
                "Name", "Payment", "Status", "Amount", "Feedback", "Ratings"
            ];

            const csvRows = filteredOrders.map((item, index) => [
                index + 1,
                item.orderId || "",
                item.vendorId || "",
                item.userCompany || "-",
                new Date(item.orderDateAndTime).toLocaleDateString(),
                new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                item.appType || "Food",
                item.orderType?.replace(/[_-]/g, "") || "-",
                item.userName || "-",
                item.paymentMethod?.replace(/[_-]/g, "") || "-",
                item.status || "-",
                Math.round(item.grandTotal) || "-",
                item.feedback || "-",
                item.ratings || "-"
            ]);

            const csvString = [headersCSV.join(","), ...csvRows.map(r => r.join(","))].join("\r\n");

            const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `orders_${new Date().toISOString().split('T')[0]}.csv`;
            link.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Export error:", err);
            alert("Failed to export data. Please try again.");
        }
    };

    // ⭐ Reset page when switching views
    const handleViewChange = (type) => {
        setViewType(type);
        setPage(0);
        setSelectedDate("");
        setSearchTerm("");
        setSearchType("orderId");

        if (type === "orders") {
            // Reset to all data
            if (allOrders.length > 0) {
                setFilteredOrders(allOrders);
                setTotalOrders(allOrders.length);
                setDisplayedOrders(allOrders.slice(0, pageSize));
            } else {
                fetchAllOrders(true);
            }
        }
    };

    // ⭐ Pagination controls
    const goNext = () => {
        if ((page + 1) * pageSize < totalOrders) {
            setPage(prev => prev + 1);
        }
    };

    const goPrevious = () => {
        if (page > 0) setPage(page - 1);
    };

    // ⭐ Get visible page numbers
    const getVisiblePages = () => {
        const totalPages = Math.ceil(totalOrders / pageSize);

        if (totalPages <= 3) {
            return Array.from({ length: totalPages }, (_, i) => i);
        }

        if (page === 0) return [0, 1, 2];
        if (page === totalPages - 1) return [page - 2, page - 1, page];
        return [page - 1, page, page + 1];
    };

    return (
        <div style={{ padding: "20px", marginBottom: "0px" }}>
            {/* TAB BUTTONS CONTAINER */}
            {/* <div className="sticky-top py-1 px-1" style={{ top: '50px', backgroundColor: 'white', zIndex: 101 }}>
                <div className="row g-2 justify-content-center justify-content-sm-evenly">
                    {["Orders", "Wallet Orders"].map((label) => {
                        const isActive = viewType === label.toLowerCase().replace(" ", "");
                        return (
                            <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
                                <button
                                    onClick={() => handleViewChange(label.toLowerCase().replace(" ", ""))}
                                    style={{
                                        border: "none",
                                        borderRadius: "10px",
                                        minWidth: "140px",
                                        width: "100%",
                                        padding: "0 10px",
                                        height: "40px",
                                        backgroundColor: isActive ? "rgb(230 109 51)" : "#d9d9d9",
                                        color: isActive ? "#fff" : "#000",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        transition: "background-color 0.3s ease",
                                        fontSize: "1rem",
                                    }}
                                >
                                    {label}
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div> */}

            {/* Tab Content Container */}
            <div style={{ marginTop: '-10px' }}>
                {viewType === "orders" ? (
                    <>
                        {/* FILTERS */}
                        <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: "10px" }}>
                            {/* Search Type Dropdown */}
                            <select
                                value={searchType}
                                onChange={(e) => {
                                    setSearchType(e.target.value);
                                    setSearchTerm("");
                                    setTimeout(() => handleFilterChange(), 100);
                                }}
                                style={{
                                    backgroundColor: "rgb(230 109 51)",
                                    color: "#fff",
                                    border: "none",
                                    height: "35px",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                    minWidth: "150px"
                                }}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                            {/* Search Input */}
                            <input
                                type="text"
                                placeholder={getPlaceholderText()}
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setTimeout(() => handleFilterChange(), 300);
                                }}
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    color: "#333",
                                    border: "1px solid #ced4da",
                                    height: "35px",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                    width: "200px",
                                }}
                            />

                            <input
                                type="date"
                                value={selectedDate}
                                onChange={(e) => {
                                    setSelectedDate(e.target.value);
                                    setTimeout(() => handleFilterChange(), 100);
                                }}
                                style={filterSelectStyle}
                            />

                            <button
                                onClick={() => {
                                    setSelectedDate("");
                                    setSearchTerm("");
                                    setSearchType("orderId");
                                    setTimeout(() => handleFilterChange(), 100);
                                }}
                                style={{
                                    backgroundColor: "#6c757d",
                                    color: "white",
                                    border: "none",
                                    height: "35px",
                                    borderRadius: "4px",
                                    padding: "0 15px",
                                    cursor: "pointer",
                                }}
                            >
                                Clear Filters
                            </button>

                            <div style={{ marginLeft: "auto" }}>
                                <button onClick={handleExport} style={filterButtonStyle}>
                                    Export Orders ({filteredOrders.length})
                                </button>
                            </div>
                        </div>

                        {/* TABLE */}
                        <div className="table-responsive" style={{ maxHeight: 'calc(90vh - 265px)', overflowY: 'auto', maxWidth: '1215px' }}>
                            <table className="table table-bordered table-striped align-middle">
                                <thead style={{ position: 'sticky', top: 0, zIndex: 100 }}>
                                    <tr>
                                        <th style={headerStyle}>Order ID</th>
                                        <th style={headerStyle}>Vendor ID</th>
                                        <th style={headerStyle}>Company Name</th>
                                        <th style={headerStyle}>Date</th>
                                        <th style={headerStyle}>Time</th>
                                        <th style={headerStyle}>Category</th>
                                        <th style={headerStyle}>Type</th>
                                        <th style={headerStyle}>Name</th>
                                        <th style={headerStyle}>Payment</th>
                                        <th style={headerStyle}>Status</th>
                                        <th style={headerStyle}>Amount</th>
                                        <th style={headerStyle}>Feedback</th>
                                        <th style={headerStyle}>Ratings</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading && allOrders.length === 0 ? (
                                        <tr>
                                            <td colSpan="13" style={{ textAlign: 'center', fontStyle: 'italic' }}>
                                                Loading orders...
                                            </td>
                                        </tr>
                                    ) : displayedOrders.length > 0 ? (
                                        displayedOrders.map((item, index) => (
                                            <tr key={`${item.orderId}_${index}`}>
                                                <td style={cellStyle}>{item.orderId}</td>
                                                <td style={cellStyle}>{item.vendorId}</td>
                                                <td style={cellStyle}>{item.userCompany || "-"}</td>
                                                <td style={cellStyle}>
                                                    {(() => {
                                                        const d = new Date(item.orderDateAndTime);
                                                        return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
                                                    })()}
                                                </td>
                                                <td style={cellStyle}>{new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</td>
                                                <td style={cellStyle}>{item.appType || "Food"}</td>
                                                <td style={cellStyle}>{item.orderType?.replace(/[_-]/g, "") || "-"}</td>
                                                <td style={cellStyle}>{item.userName || "-"}</td>
                                                <td style={cellStyle}>
                                                    <span style={{
                                                        color: item.paymentMethod?.toLowerCase().includes("wallet") ? "#28a745" : "inherit",
                                                        fontWeight: item.paymentMethod?.toLowerCase().includes("wallet") ? "bold" : "normal"
                                                    }}>
                                                        {item.paymentMethod?.replace(/[_-]/g, "") || "-"}
                                                    </span>
                                                </td>
                                                <td style={cellStyle}>{item.status || "-"}</td>
                                                <td style={cellStyle}>₹{Math.round(item.grandTotal) || "-"}</td>
                                                <td style={cellStyle}>{item.feedback || "-"}</td>
                                                <td style={cellStyle}>
                                                    {[1, 2, 3, 4, 5].map(star => (
                                                        <span key={star} style={{ color: item.ratings >= star ? "#FFD700" : "#ccc" }}>★</span>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="13" style={{ textAlign: 'center', fontStyle: 'italic' }}>
                                                {allOrders.length === 0 ? "No orders found." : "No orders match your filters."}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* PAGINATION */}
                        {totalOrders > 0 && (
                            <div className="d-flex justify-content-center mt-3" style={{ gap: "10px" }}>
                                <button
                                    disabled={page === 0}
                                    onClick={goPrevious}
                                    className="btn btn-primary"
                                >
                                    Previous
                                </button>

                                {getVisiblePages().map((p) => (
                                    <button
                                        key={p}
                                        onClick={() => setPage(p)}
                                        className={`btn ${page === p ? "btn-primary" : "btn-outline-primary"}`}
                                    >
                                        {p + 1}
                                    </button>
                                ))}

                                <button
                                    disabled={(page + 1) * pageSize >= totalOrders}
                                    onClick={goNext}
                                    className="btn btn-primary"
                                >
                                    Next
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <Fooduserwalletorders />
                )}
            </div>
        </div>
    );
};

const headerStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "#fff",
    textAlign: "center",
    padding: "8px",
    border: "1px solid #ddd",
    position: 'sticky',
    top: 0,
    zIndex: 100
};

const cellStyle = {
    textAlign: "center",
    padding: "8px",
    border: "1px solid #ddd",
};

export default Fooduserorders;